import { splitAmountEvenly } from 'lib/numbers/splitAmountEvenly'
import { floatify } from 'lib/maths/mathUtils'

export function buildBundledExperienceTotalsByParentItemId(
  experienceItems: Array<App.Checkout.ExperienceItemView>,
  transferItems: Array<App.Checkout.TransferItemView> = [],
): Record<string, { price: number, memberPrice: number }> {
  const totalsByParentItemId: Record<string, { price: number, memberPrice: number }> = {}
  for (const view of [...experienceItems, ...transferItems]) {
    if (!view.item.isAccomBundle) continue
    const parentItemIds = view.item.bundledItemIds
    if (!parentItemIds?.length) continue

    const priceShares = splitAmountEvenly(view.totals.price ?? 0, parentItemIds.length)
    const memberPriceShares = splitAmountEvenly(view.totals.memberPrice ?? 0, parentItemIds.length)

    parentItemIds.forEach((parentItemId, i) => {
      const existing = totalsByParentItemId[parentItemId] ?? { price: 0, memberPrice: 0 }
      totalsByParentItemId[parentItemId] = {
        price: floatify(existing.price + priceShares[i]),
        memberPrice: floatify(existing.memberPrice + memberPriceShares[i]),
      }
    })
  }
  return totalsByParentItemId
}

export function sumBundledExperienceShareForParent(
  children: Array<{ total?: number | null, bundledItemIds?: Array<string> }>,
  parentItemId: string,
): number {
  return floatify(children.reduce((sum, child) => {
    const parents = child.bundledItemIds ?? []
    const indexInParents = parents.indexOf(parentItemId)
    if (indexInParents === -1) return sum
    const shares = splitAmountEvenly(child.total ?? 0, parents.length)
    return sum + shares[indexInParents]
  }, 0))
}
